import React, { useContext } from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { Link } from "gatsby";
import { truncate } from "gatsby-frontend";
import { SiteContext } from "gatsby-frontend/src/Site";

function BreadcrumbsComponent({ ancestors, title }) {
	const { isRestricted } = useContext(SiteContext);
	return (
		<Breadcrumbs className="breadcrumbs">
			<Link to="/">
				<HomeIcon />
			</Link>
			{ancestors.map((a, i) => {
				return i + 1 < ancestors.length ? (
					<Link key={a.id} to={a.slug}>
						{a.title}
					</Link>
				) : (
					<Typography key={a.id}>
						{isRestricted
							? "... " + isRestricted
							: truncate(title ? title : a.title)}
					</Typography>
				);
			})}
		</Breadcrumbs>
	);
}

export default BreadcrumbsComponent;
